import React, { useContext } from 'react';
import { MegaMenuSectionTitle } from './MegaMenuSectionTitle';
import { MegaMenuLink } from './MegaMenuLink';
import { MegaMenuSettingsModal } from 'src/components/Header/components/MegaMenu/MegaMenuSettingsModal';
import { AccountHeaderContext } from 'src/lib/AccountHeaderContext';
import { useMegaMenu } from 'src/components/Header/components/MegaMenu/useMegaMenu';

export const MegaMenuAccountPage = () => {
  const { megaMenuState, settingsMenuState } = useMegaMenu();
  const { bidCart, bidsSubmitted, messages } = useContext(AccountHeaderContext);
  return (
    <div className='flex flex-row justify-between gap-10 py-5' id='mega-menu-account-page'>
      <div className='flex flex-col gap-3'>
        <div className='flex flex-col gap-2 w-full max-w-[271px]'>
          <MegaMenuSectionTitle title='Bidding'/>
        </div>
        <div className='grid xl:grid-cols-2 gap-x-10 gap-y-4'>
          <div className='flex flex-col gap-1 w-full max-w-[271px] xl:h-[64px]'>
            <MegaMenuLink notificationCount={bidsSubmitted} to='/account/bids' onPress={() => megaMenuState.close()}label='My Bids' description='Track your active bids.'/>
          </div>
          <div className='flex flex-col gap-1 w-full max-w-[271px] xl:h-[64px]'>
            <MegaMenuLink notificationCount={bidCart} to='/account/cart' onPress={() => megaMenuState.close()} label='Bid Cart' description='These bids have not been finalized.'/>
          </div>
          <div className='flex flex-col gap-1 w-full max-w-[271px] xl:h-[64px]'>
            <MegaMenuLink to='/account/won-auctions' onPress={() => megaMenuState.close()} label='Won Auctions' description='View your winning bids.'/>
          </div>
          <div className='flex flex-col gap-1 w-full max-w-[271px] xl:h-[64px]'>
            <MegaMenuLink to='/account/wishlist' onPress={() => megaMenuState.close()} label='Wishlist' description='Save your favorite items to watch or bid on later. '/>
          </div>
        </div>
      </div>
      <div className='flex flex-col gap-3'>
        <div className='flex flex-col gap-2 w-full max-w-[271px]'>
          <MegaMenuSectionTitle title='Account'/>
        </div>
        <div className='grid gap-x-10 gap-y-4'>
          <div className='flex flex-col gap-1 w-full max-w-[271px]'>
            <MegaMenuLink to='/account' onPress={() => megaMenuState.close()} label='Profile' />
          </div>
          <div className='flex flex-col gap-1 w-full max-w-[271px]'>
            <MegaMenuLink notificationCount={messages} to='/account/messages' onPress={() => {megaMenuState.close();}} label='Messages'/>
          </div>
          <div className='flex flex-col gap-1 w-full max-w-[271px]'>
            <MegaMenuLink to='/account/consignment' onPress={() => megaMenuState.close()} label='Consigning'/>
          </div>
          <div className='flex flex-col gap-1 w-full max-w-[271px]'>
            <MegaMenuLink onPress={()=>{
              settingsMenuState.toggle();
            }} label='Settings'/>
            <MegaMenuSettingsModal/>
          </div>
        </div>
      </div>
      <div className='flex flex-col gap-3'>
        <div className='flex flex-col gap-2 w-full max-w-[271px]'>
          <MegaMenuSectionTitle title='Others'/>
        </div>
        <div className='grid gap-x-10 gap-y-4'>
          <div className='flex flex-col gap-1 w-full max-w-[271px]'>
            <MegaMenuLink to='/account/textalerts' onPress={() => megaMenuState.close()} label='Text Alerts'/>
          </div>
          <div className='flex flex-col gap-1 w-full max-w-[271px]'>
            <MegaMenuLink to='/account/phone-book' onPress={() => megaMenuState.close()} label='Phone Book'/>
          </div>
          <div className='flex flex-col gap-1 w-full max-w-[271px]'>
            <MegaMenuLink to='/account/address-book' onPress={() => megaMenuState.close()} label='Address Book'/>
          </div>
          <div className='flex flex-col gap-1 w-full max-w-[271px]'>
            <MegaMenuLink to='/account/credit-cards' onPress={() => megaMenuState.close()} label='Credit Cards'/>
          </div>
        </div>
      </div>
    </div>
  );
};
